import React, {Component} from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from 'react-redux';
import apiPreshift from '../../../api/apiPreshift';
import { errorNotify } from '../../../helpers/functions';
import { addBreamb, resetBreamb } from '../../../reducers/breams-manage';
import {pageLoadManageActions as loader} from "../../../reducers/load";
import Breams from '../../blocks/Breams';
import Loader from '../../blocks/Loader';
import { notify } from '../../blocks/Notify';
import CoursViewer from '../../screens/electronicCourses/CoursViewer';
import QuestionStepper from '../../steppers/QuestionStepper';
import LessonViewer from '../../screens/electronicCourses/LessonViewer';

class ElectronicViewContainer extends Component {
    constructor(props) {
            super(props);
                   
            this.state ={      
                content: CoursViewer,      
                course_title: '',
                current_position: 'course',
                is_exit_timer: true,
                current_lesson : null,
                course:null
            };

            
        };

        componentDidMount(){
            this.handlePrepereData();
        }
        componentWillUnmount(){
            this.clearData();
        }

        clearData = ()=>{
            //console.log('clearData')
        }

        handlePrepereData = () => {             
                document.title = this.props.t('Demo view electronic courses');
                resetBreamb();                
                this.getCoursData();                
            };

        getCoursData = () => {
            return new Promise((resolve, reject) => {
                loader.start("El-courses-view");                
                let coursUuid = window.location.hash.replace("#/demo-course?uuid=", "")                            
                apiPreshift.getElectronicCourse(coursUuid)
                .then(response => {                    
                    addBreamb({title: this.props.t('Demo view electronic courses')+" "+response.data.title});
                    this.setState({course: response.data});
                    resolve();
                })
                .catch(e => {
                    console.log(e);
                })
                .finally(() => loader.stop("El-courses-view"))
        })
        
        };
        handleChangeContent = (new_content, id) => {
             return new Promise((resolve, reject) => {                
                switch(new_content)
                {
                    case 'viewLesson':                        
                        this.setState(
                            {
                                content:LessonViewer,
                                current_lesson: this.state.course.lessons[id]
                            });                           
                        loader.stop("El-courses-view"); 
                        resolve();                     
                        break;
                    case 'viewCourse':
                        this.setState(
                            {
                                content:CoursViewer,
                                current_lesson: null
                            }
                        )
                        break;
                }
            });
        }
        render() {       
            let Content = this.state.content;                  
                return <Loader isLoading={this.props.load.isLoading} loadId={"El-courses"}
                                justifyContent="center" className="Screen h-100">                 
                            <Breams/>                                       
                            <Content {...this.state} {...this.props}
                                handleChangeContent = {this.handleChangeContent}
                            />                                   
                        </Loader>
            }
}
const mapStateToProps = (store) => {
    return {
        app: store.appState,
        load: store.loadState,
        user: store.userState
    };
};
export default connect(mapStateToProps)(withTranslation()(ElectronicViewContainer));